var scrolled;

jQuery('#hamburger-btn').click(function() {
  scrolled = jQuery( window ).scrollTop();
  handleMobileNavClick();
});

jQuery('#mobilenav-close').click(function() {
  handleMobileNavClick();
});

function handleMobileNavClick() {

  if (  jQuery('#hamburger-btn').hasClass('open')  ) {
    jQuery('.mobile-navigation-container').toggleClass('open');
    jQuery('#hamburger-btn').removeClass('open');
    jQuery('#mobilenav-close').toggleClass('open');
    jQuery('body').toggleClass('no-scroll');
  } else {
    jQuery('.mobile-navigation-container').removeClass('open');
    jQuery('#mobilenav-close').removeClass('open');
    jQuery('#hamburger-btn').toggleClass('open');
    jQuery('body').removeClass('no-scroll');
    jQuery( window ).scrollTop(scrolled);
  }
}

jQuery(window).on('load', function() { 
	jQuery('.hero__wrapper--etusivu iframe').fadeIn( 3000 );
});

jQuery( window ).scroll( function() {
  fixedHeader();
});

jQuery( window ).resize( function() {
  fixedHeader();
});

jQuery( document ).ready( function() {
  fixedHeader();
});

function fixedHeader() {
  if ( jQuery( window ).scrollTop() > 100 ) {
    jQuery('#header').addClass('fixed');
  } else {
    jQuery('#header').removeClass('fixed');
  }
}